import { render, staticRenderFns } from "./VehicleBasedata.vue?vue&type=template&id=05bfe9ba"
import script from "./VehicleBasedata.vue?vue&type=script&lang=js"
export * from "./VehicleBasedata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports